function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*----------------------------------------------------------------------------
Import modules
----------------------------------------------------------------------------*/

/*----------------------------------------------------------------------------
The mobile menu
----------------------------------------------------------------------------*/
// Holds the mobile menus
var menus = {};
var links = [];
var button = document.querySelector('.js-mobile-menu--toggle');

var open = function open(ID) {
  // Open the requested menu
  for (var key in menus) {
    if (Object.hasOwnProperty.call(menus, key)) {
      menus[key].classList.toggle('is-open', key == ID);
    }
  }

  if (menus[ID]) {
    window.ScrollLocker.lock();
  }
};

var close = function close() {
  // Close all menus
  for (var key in menus) {
    if (Object.hasOwnProperty.call(menus, key)) {
      menus[key].classList.remove('is-open');
    }
  }

  window.ScrollLocker.unlock();
}; // Loop through all the menus and organise them


_toConsumableArray(document.querySelectorAll('.mobile-menu[data-menu-id]')).forEach(function (menu) {
  menus[menu.getAttribute('data-menu-id')] = menu; // Put all this menu's links into the links array

  links.push.apply(links, _toConsumableArray(menu.querySelectorAll('a[data-link-id]'))); // If we ever click directly on the menu, we need to close it

  menu.addEventListener('click', function (e) {
    if (e.target === menu) close();
  });
});

links.forEach(function (link) {
  var ID = link.getAttribute('data-link-id'); // If there is a menu for this item

  if (menus[ID]) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      open(ID);
    });
  }
});
window.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') close();
}); // When we click the hamburger button, open the main menu

button.addEventListener('click', function (e) {
  return open("0");
});